import { render } from "./singlePrice.vue?vue&type=template&id=21a014ba&ts=true"
import script from "./singlePrice.vue?vue&type=script&lang=ts"
export * from "./singlePrice.vue?vue&type=script&lang=ts"

import "./singlePrice.vue?vue&type=style&index=0&id=21a014ba&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__